// removed by extract-text-webpack-plugin
module.exports = {"preview":"_3Fyuu"};